/** ChartFilter.jsx - the date-window control that sits on a chart's header. */
import { FILTER_OPTIONS } from './chartFilters';

/* ===== CHART FILTER COMPONENT ===== */
export const CF_SELECT = {
  padding: '5px 10px',
  borderRadius: 6,
  border: '1px solid #E0E0E0',
  fontSize: 10,
  fontFamily: 'Montserrat',
  outline: 'none',
  cursor: 'pointer',
  background: '#fff',
  color: '#333',
  fontWeight: 600,
};
export const CF_DATE = { padding: '4px 8px', borderRadius: 6, border: '1px solid #E0E0E0', fontSize: 10, fontFamily: 'Montserrat' };
export const CF_APPLY = {
  padding: '4px 10px',
  borderRadius: 6,
  fontSize: 10,
  fontWeight: 700,
  background: '#1B5E20',
  color: '#fff',
  border: 'none',
  cursor: 'pointer',
  fontFamily: 'Montserrat',
};

export function ChartFilter({ value, onChange, showCustom, customFrom, customTo, onCustomFromChange, onCustomToChange, onApplyCustom }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 6, flexWrap: 'wrap' }}>
      <select value={value} onChange={(e) => onChange(e.target.value)} style={CF_SELECT}>
        {FILTER_OPTIONS.map((o) => (
          <option key={o.value} value={o.value}>
            {o.label}
          </option>
        ))}
      </select>
      {showCustom && (
        <>
          <input type="date" value={customFrom || ''} onChange={(e) => onCustomFromChange(e.target.value)} style={CF_DATE} />
          <span style={{ fontSize: 9, color: '#5A5A5A' }}>to</span>
          <input type="date" value={customTo || ''} onChange={(e) => onCustomToChange(e.target.value)} style={CF_DATE} />
          <button onClick={onApplyCustom} style={CF_APPLY}>
            Apply
          </button>
        </>
      )}
    </div>
  );
}
